@use '@lib/assets/styles/main.scss' as *;

.filterWrap {
  padding-bottom: 16px;
}

.filter {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 16px;
  align-items: center;
  justify-content: space-between;
}

.filterRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dateRangePickerCol {
  width: 288px; // DatePicker drop-down width
}

.sortingBtn {
  display: block;
}
